import { IUpdateCategoriaAssistenciaUseCase } from "../../../presentation/useCases/update/update_categoria_assistencia_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateCategoriaAssistenciaUseCase
 */

export class UpdateCategoriaAssistenciaUseCase implements IUpdateCategoriaAssistenciaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updateCategoriaAssistencia(
    idCategoriaAssistencia: number,
    status: number,
    categoria: string,
  ): Promise<void> {
    await this.repository.updateCategoriaAssistencia(
      idCategoriaAssistencia,
      status,
      categoria,
    );
  }
}
